"use client";

import React from "react";

const ReturnsPolicy = () => {
	return (
		<section className="prose-legal mx-auto max-w-3xl px-5 py-section-sm sm:px-8">
			<div>
				<h1 className="text-center font-serif text-display font-light text-mg-black">Return Policy</h1>
				<p className="label-caps mt-4 text-center text-ink-faint">Last updated 07/05/2024</p>
				<div className="hairline mx-auto my-8 w-16" />
				<p>
					Maicro Labs, LLC, of 90 State St. STE 700, Office 40, Albany, NY 12207 United States of America,
					(collectively, &quot;Maicro Labs&quot;, &quot;Maicro Labs, LLC&quot;, &quot;Micrographer&quot;,
					&quot;our&quot; or &quot;we&quot;) understand circumstances in which a return may be necessary.
				</p>
				<p className="mt-4">
					This Return Policy describes our policies for returns on orders from{" "}
					<a href="https://www.micrographer.com" className="underline">
						https://www.micrographer.com
					</a>{" "}
					(the “Site”).
				</p>

				<h2 className="mt-8 text-2xl font-semibold">General</h2>
				<p className="mt-4">
					Every product sold by Micrographer is “made to order,” which means it is specifically manufactured
					just for you only after you have placed your Order. Accordingly, we do not accept refunds, returns
					or exchanges for orders. We are also unable to make any changes or cancellations to orders after the
					Order is placed.
				</p>

				<h2 className="mt-8 text-2xl font-semibold">Damage Reviews</h2>
				<p className="mt-4">
					On rare occasions, one or more products in an Order may be damaged while in transit in possession of
					our shipping partners. If one or more of your product(s) arrives damaged, please send detailed
					information through the form on the{" "}
					<a href="https://www.micrographer.com/contact" className="underline">
						Contact Page
					</a>
					. In cases where one or more product(s) is materially damaged, Micrographer may elect to restore or
					replace the damaged product(s) in Micrographer’s sole discretion following a review of the photos
					submitted (“Damage Review”).
				</p>
				<p className="mt-4">
					Requests for damage reviews will involve guidelines for submitting and attempting to verify with the
					respective shipping carrier for your order, including but not limited to the United States Postal
					Service.{" "}
					<span className="font-semibold underline">
						Therefore, we ask that information (outlined below), not be falsified or fabricated in any way.
					</span>
				</p>
				<p className="mt-4">
					If requesting a Damage Review, you expressly acknowledge and agree to the following:
				</p>
				<ul className="mt-2 list-inside list-disc">
					<li>
						Photos of damaged areas of product(s) must be clearly visible and submitted in .jpeg or .png
						format;
					</li>
					<li>
						Photos of damage must be received by Micrographer no fewer than seventy-two (72) hours following
						the indicated delivery date of the applicable Order by the shipping provider responsible for
						delivering the Order;
					</li>
					<li>
						Photos of the damage must have been taken immediately following receipt of the product(s), and the
						product(s) must not have been hung, placed or otherwise installed prior to photos of the damage
						being taken;
					</li>
					<li>
						A Damage Review requires up to thirty (30) business days to complete, and Micrographer may elect
						to replace or repair the damaged product in its sole discretion; and
					</li>
					<li>
						The delivery of a replacement product, if any, will be subject to then existing manufacturing
						capacity, inventory, availability and shipping timing, and you may be responsible for payment of
						return shipping in the event that Micrographer elects to repair or replace the product(s).
					</li>
				</ul>
			</div>
		</section>
	);
};

export default ReturnsPolicy;
